// Should stay in sync with recentUpdatesNotificationTypes.mjs

export const RECENT_UPDATES_NOTIFICATION_TYPES = {
  APPRAISAL_RESULTS: 0,
  PERFORMANCE_REPORTS: 1,
  REAPPRAISAL_RATIONALES: 2,
  CHECKPOINTS: 3,
  CHANGE_DATE_REQUEST_EDIT_EVENT_REVIEW: 4,
  CHANGE_DATE_REQUEST_REVIEW_PAGE: 5,
  OBSERVATION_REPORT_REVIEW_PAGE: 6
};
